import React from 'react';
import {ErrorModal} from '@igp/shared/components/error';
import {withTraceErrorBoundary} from '@igp/shared/otel';

import {withAccessCheck} from '@access-control';

import {playerLevelReportGlobalSpinsResource} from './permissions';
import {PlayerLevelReportBase} from './PlayerLevelReportBase';

function PlayerLevelReportGlobalSpinsInner() {
    return <PlayerLevelReportBase tab="globalSpins" columnsSettingsViewType="PlayerLevelReportGlobalSpins" />;
}

const PlayerLevelReportGlobalSpinsWithAccess = withAccessCheck(PlayerLevelReportGlobalSpinsInner, playerLevelReportGlobalSpinsResource);

export const PlayerLevelReportGlobalSpins = withTraceErrorBoundary(PlayerLevelReportGlobalSpinsWithAccess, ErrorModal);
